import Request from '@/requests/Request'

const resource = "/projetos/{projetoId}/pessoas-alcancadas";

export default {
  findByParentId(projetoId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.get(url)
  },

  delete(payload) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)

    return Request.delete(`${url}/${payload.pessoaAlcancadaId}`)
  },

  put(payload) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)

    return Request.put(`${url}/${payload.pessoaAlcancadaId}`, payload.pessoaAlcancada)

  },

  post(payload) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)

    return Request.post(`${url}`, payload.pessoaAlcancada)

  },
}